import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import type { collectionCardRelayFragment$key } from "@/__generated__/collectionCardRelayFragment.graphql";
import { CollectionCard } from "@/components/confluence/templates/collection-card";
import { CollectionOrderKey } from "@/templates/software/confluence/templates/confluence-templates-page/src/config/collection-order.ts";

const CollectionCardFragment = graphql`
    fragment collectionCardRelayFragment on ContentPlatformTemplateCollection {
        collectionId
        name
        urlSlug
        collectionIcon {
            url
        }
        howToUseThisCollection {
            collectionSteps {
                __typename
            }
        }
    }
`;

export type CollectionCardProps = {
    collection: collectionCardRelayFragment$key;
};

export const CollectionCardRelay = ({ collection }: CollectionCardProps) => {
    const data = useFragment(CollectionCardFragment, collection);
    return (
        <CollectionCard
            urlSlug={data.urlSlug as CollectionOrderKey}
            templateCount={
                data.howToUseThisCollection?.collectionSteps?.length ?? 0
            }
            name={data.name ?? ""}
        />
    );
};
